import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import enUS from "date-fns/locale/en-US";
import es from "date-fns/locale/es";
import ptBR from "date-fns/locale/pt-BR";
import React from "react";
import { Route } from "react-router-dom";
import { Spinner } from "../Common/Spinner";
import NavigationBar from "../Layout/navigationBar/NavigationBar";
import getRoutes from "./RoutesMap";

const Routes = (props: any) => {  
  const locale = () => {
    switch (props.i18n.language) {
      case "pt":
        return ptBR;
      case "us":
        return enUS;
      case "es":
        return es;
      default:
        return ptBR;
    }
  };

  return (
    <>
      {getRoutes().map((route: any) => {
        const Component = route.component;

        return (
          <Route
            exact
            path={route.path}
            key={route.path}
            render={(renderProps: any) => (
              <>
                <Spinner active={props.showSpinner}>
                  <MuiPickersUtilsProvider locale={locale()} utils={props.DateFnsUtils}>
                    {route.softwareManagement ? (
                      <Component {...renderProps} {...route.props} />                   
                    ) : (
                      <NavigationBar provider={props.authProvider} i18n={props.i18n}>
                        <Component {...renderProps} {...route.props} />                   
                      </NavigationBar>
                    )}
                  </MuiPickersUtilsProvider>
                </Spinner>
              </>
            )}
          />
        ); 
      })}
    </>
  );
};
export default Routes;
